export enum ContactsCountsEnum {
  count_0_1K = '0 - 1K',
  count_1K_10K = '1K - 10K',
  count_10K_50K = '10K - 50K',
  count_50K_100K = '50K - 100K',
  count_100K_250K = '100K - 250K',
  count_250K_andMore = '250K+',
}

export type IContactsCount = {
  id: ContactsCountsEnum
  label: string
}

export const CONTACTS_COUNTS: IContactsCount[] = [
  { id: ContactsCountsEnum.count_0_1K, label: '0 - 1K' },
  { id: ContactsCountsEnum.count_1K_10K, label: '1K - 10K' },
  { id: ContactsCountsEnum.count_10K_50K, label: '10K - 50K' },
  { id: ContactsCountsEnum.count_50K_100K, label: '50K - 100K' },
  { id: ContactsCountsEnum.count_100K_250K, label: '100K - 250K' },
  { id: ContactsCountsEnum.count_250K_andMore, label: '250K+' },
]
